export default {
      id: "zoom-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#zoom",
      toString: function () {
        return this.url;
      }
    }